import { LanguageEnumDtoSchema } from "@iot-platform/core";
import * as z from "zod";

export const CurrentUserDtoSchema = z
    .object({
        id: z.number().nonnegative(),
        username: z.string().trim().nullable(),
        email: z.string().trim(),
        roles: z.array(z.string().trim()).nullable(),
        locale: LanguageEnumDtoSchema.nullable(),
        time_zone: z.string().trim(),
    })
    .readonly();

export type CurrentUserDto = z.output<typeof CurrentUserDtoSchema>;
